// Explicit page imports for production builds
// This bypasses Vite's glob pattern issues
export const pageComponents: Record<string, () => Promise<any>> = {
    'welcome': () => import('./pages/welcome'),
    'Welcome': () => import('./pages/welcome'),
    'value-journey': () => import('./pages/value-journey'),
    'ValueJourney': () => import('./pages/value-journey'),
    'dashboard': () => import('./pages/account-dashboard'),
    'Dashboard': () => import('./pages/account-dashboard'),
    'value-centre': () => import('./pages/dashboard-page'),
    'ValueCentre': () => import('./pages/dashboard-page'),
    'referrals': () => import('./pages/referrals-page'),
    'ReferralsPage': () => import('./pages/referrals-page'),
    'account-dashboard': () => import('./pages/account-dashboard'),
    'auth/login': () => import('./pages/auth/login'),
    'auth/register': () => import('./pages/auth/register-new'),
    'Auth/RegisterNew': () => import('./pages/auth/register-new'),
    'auth/register-new': () => import('./pages/auth/register-new'),
    'landing-page': () => import('./pages/landing-page'),
    'sandbox/landing-page': () => import('./pages/sandbox/landing-page'),
    'hubs/ecosystem-hub': () => import('./pages/hubs/ecosystem-hub'),
    'hubs/unicorn-journey-matrix': () => import('./pages/hubs/unicorn-journey-matrix'),
    'news': () => import('./pages/news'),
    'mobile-landing': () => import('./pages/mobile-landing'),
    'warrior/warrior-dashboard': () => import('./pages/warrior/warrior-dashboard'),
    'test-pulse-page': () => import('./pages/test-pulse-page'),
    'Sandbox/FeedRebuild': () => import('./pages/sandbox/feed-rebuild'),
    'intel-sandbox': () => import('./pages/intel-sandbox'),
    'Sandbox/UnicornParadise': () => import('./pages/sandbox/unicorn-paradise'),
    'Sandbox/MatchingEngine': () => import('./pages/sandbox/matching-engine'),
    'sandbox/composer-playground': () => import('./pages/sandbox/composer-playground'),
    // Business Native AI
    'business-native-ai/index': () => import('./pages/business-native-ai/index'),
    'business-native-ai/assessment': () => import('./pages/business-native-ai/assessment'),
    'business-native-ai/certificate': () => import('./pages/business-native-ai/certificate'),
    'error/restricted': () => import('./pages/error/restricted'),
    // Leaderboards
    'leaderboards/index': () => import('./pages/leaderboards/index'),
    'leaderboards': () => import('./pages/leaderboards'),
    // Simulation
    'simulation/shark-tank': () => import('./pages/simulation/shark-tank'),
    // Throne Room
    'throne-room/index': () => import('./pages/throne-room/index'),
    'throne-room/proclamation': () => import('./pages/throne-room/proclamation'),
    // MarketSpace
    'market-space/landing': () => import('./pages/market-space/landing'),
    'market-space/stakeholder-detail': () => import('./pages/market-space/stakeholder-detail'),
    'market-space/dashboard': () => import('./pages/market-space/dashboard'),
    'market-space/listing-form': () => import('./pages/market-space/listing-form'),
    // Merit & Recognition System components
    'director-dashboard': () => import('./pages/director-dashboard'),
    'admin-dashboard': () => import('./pages/admin-dashboard'),
    'leaderboard-detail': () => import('./pages/leaderboard-detail'),
    'admin/growth-dashboard': () => import('./pages/admin/growth-dashboard'),
    'admin/analytics-dashboard': () => import('./pages/admin/analytics-dashboard'),
    'admin/unltx': () => import('./pages/admin/unltx'),
    'admin/test-page': () => import('./pages/admin/test-page'),
    'admin/user-audit': () => import('./pages/admin/user-audit'),
    // Phase 3 Payments
    'payment/CheckoutPage': () => import('./pages/auth/register-new'),
    'payment/TransactionHistoryPage': () => import('./pages/payment/transaction-history-page'),
    'payment/InvoiceViewerPage': () => import('./pages/payment/invoice-viewer-page'),
    'marketplace/OrderManagementPage': () => import('./pages/marketplace/order-management-page'),
    'dashboard/RevenueAnalyticsPage': () => import('./pages/dashboard/revenue-analytics-page'),
    'roi-value-bonus-calculator': () => import('./pages/roi-value-bonus-calculator'),
    'pricing/subscription-plans': () => import('./pages/pricing/subscription-plans'),
    'knowledge-base-page': () => import('./pages/knowledge-base-page'),
    'launch-blog': () => import('./pages/launch-blog'),
    'pitch-deck-maker-page': () => import('./pages/pitch-deck-maker-page'),
    'features/feature-detail': () => import('./pages/features/feature-detail'),
    'features/demo-day': () => import('./pages/features/demo-day'),
    'features/access-demo-day': () => import('./pages/features/access-demo-day'),
    'features/suggest': () => import('./pages/features/suggest'),
    'features/ai-tools': () => import('./pages/features/ai-tools'),
    'features/market-intel': () => import('./pages/features/market-intel'),
    'features/investor-matching': () => import('./pages/features/investor-matching'),
    'features/mentorship': () => import('./pages/features/mentorship'),
    'features/acceleration': () => import('./pages/features/acceleration'),
    'features/community': () => import('./pages/features/community'),
    'features/learning': () => import('./pages/features/learning'),
    'features/triple-aces': () => import('./pages/features/triple-aces'),

    // Legal & Resources
    'terms-and-conditions': () => import('./pages/terms-and-conditions'),
    'privacy-policy': () => import('./pages/privacy-policy'),
    'refund-policy': () => import('./pages/refund-policy'),
    'contact-us': () => import('./pages/contact-us'),
    'resources/documentation': () => import('./pages/resources/documentation'),
    'resources/faq': () => import('./pages/resources/faq'),
    'resources/support': () => import('./pages/resources/support'),
    'resources/webinars': () => import('./pages/resources/webinars'),
    'resources/case-studies': () => import('./pages/resources/case-studies'),
    'resources/sources': () => import('./pages/resources/sources'),
    'legal/legal-hub': () => import('./pages/legal/legal-hub'),
    'legal/cookie-policy': () => import('./pages/legal/cookie-policy'),
    'legal/gdpr': () => import('./pages/legal/gdpr'),
    'legal/disclaimer': () => import('./pages/legal/disclaimer'),

    'SocialPulse': () => import('./pages/social-pulse'),

    // Aliases for robustness
    'Matrix': () => import('./pages/hubs/unicorn-journey-matrix'),
    'marketspace': () => import('./pages/market-space/landing'),
    'MarketSpace': () => import('./pages/market-space/landing'),
    'town-square': () => import('./pages/dashboard-page'),
    'TownSquare': () => import('./pages/dashboard-page'),

    // Tools (Premium UI)
    'Tools/UniColtQuiz': () => import('./pages/Tools/UniColtQuiz'),
    'Sandbox/Tools/PitchDeckMaker': () => import('./pages/sandbox/Tools/PitchDeckMaker'),
    'Sandbox/Tools/UnicornAssessment': () => import('./pages/sandbox/Tools/UnicornAssessment'),
    'Sandbox/Tools/InvestorMatching': () => import('./pages/sandbox/Tools/InvestorMatching'),
    'Sandbox/Tools/UnicornJourneyQuiz': () => import('./pages/sandbox/Tools/UnicornJourneyQuiz'),
    'Sandbox/Tools/ValueJourneyQuiz': () => import('./pages/sandbox/Tools/ValueJourneyQuiz'),
    'Sandbox/Tools/ValueJourneyWizard': () => import('./pages/sandbox/Tools/ValueJourneyWizard'),
    'Sandbox/Tools/BusinessModelCanvas': () => import('./pages/sandbox/Tools/BusinessModelCanvas'),
    'Sandbox/Tools/Arena': () => import('./pages/sandbox/Tools/Arena'),
};
